"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
const ApiProvider = (param)=>{
    let { children } = param;
    const { language } = (0, _i18n.useTranslationsWithNamespaces)();
    const { tenant } = (0, _environment.useEnvironment)();
    const { globalApiUrl, staticApiUrl } = (0, _configurationManager.useServiceUrls)([
        'globalApi',
        'staticApi'
    ]);
    const { token } = (0, _auth.useToken)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
        value: _constants.swrConfig,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
            baseUrl: globalApiUrl,
            language: language,
            tenant: tenant,
            token: token,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
                baseUrl: staticApiUrl,
                language: language,
                tenant: tenant,
                children: children
            })
        })
    });
};
exports.ApiProvider = ApiProvider;
